import { computed } from "vue";
import { useI18n } from "vue-i18n";
import type {
  ScheduleTemplateElement,
  ScheduleTemplateElementType,
} from "@/models/interfaces";

export function useScheduleTemplateElementTypes() {
  const { t } = useI18n();

  return computed<{ label: string; value: ScheduleTemplateElementType }[]>(
    () => [
      { label: t("Song"), value: "song" },
      { label: t("Feature"), value: "feature" },
      { label: t("Offering"), value: "collect" },
      { label: t("Communion"), value: "communion" },
      { label: t("Sermon"), value: "sermon" },
      { label: t("Slides"), value: "slides" },
    ],
  );
}

/** "1h 55m", "36m", "45s". */
export function formatTemplateDuration(totalSeconds: number): string {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  if (hours) return minutes ? `${hours}h ${minutes}m` : `${hours}h`;
  if (minutes) return `${minutes}m`;
  return `${seconds}s`;
}

/** Titles compare case-insensitively and ignoring surrounding spaces. */
export const normalizeTemplateTitle = (title: string) =>
  title.trim().toLocaleLowerCase();

export const totalTemplateDuration = (elements: ScheduleTemplateElement[]) =>
  elements.reduce((sum, element) => sum + (element.duration || 0), 0);
